export default __webpack_public_path__ + "static/media/WM0460.34I-43854_-26174_0.c295a5f5.jpg";